import React, { createContext } from "react";

import useAuth from "../../hooks/useAuth";

const AuthContext = createContext({});

const AuthProvider = ({ children }) => {
  const { isAuth, loading, user, setUser, handleLogin, handleLogout, viewingAs, startViewingAs, stopViewingAs } = useAuth();

  return (
    <AuthContext.Provider
      value={{ isAuth, loading, user, setUser, handleLogin, handleLogout, viewingAs, startViewingAs, stopViewingAs }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
